// extracted by mini-css-extract-plugin
export var container = "navigator-module--container--8a266";